import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { executeRecaptcha, loadRecaptchaScript } from '../utils/recaptcha';
import { resetSystemTheme } from '../utils/ecommerceHelper';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirect') || '/home';

  const [credentials, setCredentials] = useState({ 
    username: '', 
    password: '' 
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    resetSystemTheme();
    loadRecaptchaScript();
  }, []);

  const handleChange = (e) => {
    setCredentials({ 
      ...credentials, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Normalizamos el usuario a minúsculas y sacamos espacios
      const cleanUsername = credentials.username.toLowerCase().trim();
      const recaptchaToken = await executeRecaptcha('login');
      const loginCredentials = {
        username: cleanUsername,
        password: credentials.password,
        recaptcha_token: recaptchaToken
      };
      
      // Le pegamos al backend
      const response = await axios.post('http://localhost:8000/api/login/', loginCredentials);
      
      // Limpiar bandera de sesión para que al entrar al sistema pida la empresa
      try {
        sessionStorage.removeItem('companySelectedInSession');
      } catch {}

      onLogin(response.data, cleanUsername);
      navigate(redirectUrl);
    } catch (error) {
      console.error("Error en login:", error);
      const msg = error.response?.data?.error || 'Email o contraseña incorrectos';
      Swal.fire({
        title: 'Error',
        text: msg,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow border-0" style={{ width: '100%', maxWidth: '400px' }}>
        <div className="card-body p-5">
          <h2 className="text-center mb-2 fw-bold text-primary">SISGECOM</h2>
          <p className="text-center text-muted mb-4">Ingreso al sistema</p>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
               <label className="form-label fw-semibold">Email</label>
               <input
                 id="username"
                 name="username"
                 type="email"
                 className="form-control"
                 placeholder="ejemplo@correo.com"
                 onChange={handleChange}
                 required
               />
             </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">Contraseña</label>
              <div className="input-group">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  placeholder="••••••••"
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary d-flex align-items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary w-100 py-2 fw-bold">
              Iniciar Sesión
            </button>
          </form>
        </div>
        <div className="card-footer text-center text-muted small py-3 bg-light border-0">
          v1.0
        </div>
      </div>
    </div>
  );
};

export default Login;